import { render, staticRenderFns } from "./RecordNew.vue?vue&type=template&id=68667640&"
import script from "./RecordNew.vue?vue&type=script&lang=ts&"
export * from "./RecordNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports